define([
    'layout/util/layout',
    'layout/specificComponents/tpaWidgetNativeLayout'
], function (
    layout,
    tpaWidgetNativeLayout
) {
    'use strict';

    layout.registerRequestToMeasureDom('wysiwyg.viewer.components.tpapps.TPAWidget');
    layout.registerRequestToMeasureDom('wysiwyg.viewer.components.tpapps.TPAGluedWidget');
    layout.registerRequestToMeasureDom('wysiwyg.viewer.components.tpapps.TPASection');
    layout.registerRequestToMeasureDom('wysiwyg.viewer.components.tpapps.TPAMultiSection');
    layout.registerCustomMeasure('wysiwyg.viewer.components.tpapps.TPAWidgetNative', tpaWidgetNativeLayout.customMeasure);
});
